// providers/FavoritesProvider.tsx


import { createContext, useState, useEffect, ReactNode } from 'react';
import { Product } from '@cabukaka/types';
import { productService } from '@cabukaka/services';
import { favoriteService } from '../services/favoriteService';

export interface FavoritesContextType {
  favoriteIds: string[];
  favorites: Product[];
  isLoading: boolean;
  addToFavorites: (productId: string) => Promise<void>;
  removeFromFavorites: (productId: string) => Promise<void>;
  isFavorite: (productId: string) => boolean;
  count: number;
}

export const FavoritesContext = createContext<FavoritesContextType | undefined>(undefined);

export const FavoritesProvider = ({ children }: { children: ReactNode }) => {
  const [favoriteIds, setFavoriteIds] = useState<string[]>([]);
  const [favorites, setFavorites] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const loadFavorites = async () => {
    setIsLoading(true);
    const ids = favoriteService.getIds();
    setFavoriteIds(ids);
    
    if (ids.length > 0) {
      const products = await productService.getProductsByIds(ids);

      setFavorites(products.data);
    } else {
      setFavorites([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadFavorites();
  }, []);

  const addToFavorites = async (productId: string) => {
    favoriteService.addId(productId);
    await loadFavorites();
  };

  const removeFromFavorites = async (productId: string) => {
    favoriteService.removeId(productId);
    await loadFavorites();
  };

  const isFavorite = (productId: string) => {
    return favoriteIds.includes(productId);
  };

 return (
    <FavoritesContext.Provider value={{
      favoriteIds,
      favorites,
      isLoading,
      addToFavorites,
      removeFromFavorites,
      isFavorite,
      count: favoriteIds.length
    }}>
      {children}
    </FavoritesContext.Provider>
  );
};

